<template>
    <div v-if="showFollow" class="j-follow-layout" @click="hide" @contextmenu="hide">
        <div class="j-follow-wrap" :style="{ ...positionStyle, height: `${height}px`, width: `${width}px` }" @click.stop="followClick">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "JFollow",
        props: {
            autoHide: {
              type: Boolean,
              default: true
            },
            height: {
                type: Number,
                default: 300
            },
            width: {
                type: Number,
                default: 200
            }
        },
        data() {
            return {
                showFollow: false,
                positionStyle: {}
            }
        },
        methods: {
            show (e) {
                this.computePosition(e)
                this.showFollow = true
            },
            hide () {
                this.showFollow = false
            },
            followClick () {
              this.autoHide && this.hide()
            },
            computePosition (event) {
                const offsetX = 15
                const offsetY = 10
                const x = event.pageX + offsetX
                const y = event.pageY + offsetY
                const clientWidth = document.body.clientWidth
                const clientHeight = document.body.clientHeight
                let top = y
                let left = x
                if ((x + this.width) >= clientWidth) left = x - (this.width + offsetX)
                if ((y + this.height) >= clientHeight) top = y - (this.height + offsetY)
                this.positionStyle = { top: `${top}px`, left: `${left}px` }
            }
        }
    }
</script>

<style scoped lang="scss">
    .j-follow-layout {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;
        z-index: 9999;
        .j-follow-wrap {
            cursor: pointer;
            position: absolute;
            box-sizing: border-box;
            overflow: auto;
            &:empty {
                display: flex;
                height: 100%;
                width: 100%;
                justify-content: center;
                align-items: center;
                border: 2px dotted rgba(255,255,255, .6);
                background-color: rgba(255,255,255, .3);
                border-radius: 5px;
                &::after {
                    content: '插槽无数据';
                    font-size: 12px;
                    color: rgba(255,255,255, .6);
                }
            }
        }
    }
</style>
